import * as React from 'react'
import classNames from 'classnames'

import { checkStringPeriod } from 'ui-component-library/utils/helpers'

import HeadlineFive from '../../00-Primitives/Headlines/HeadlineFive'
import BucketBadge from '../../00-Primitives/BucketBadge'

import style from './style.scss'

type Props = {
  className?: string
  contentText: string
  headerText: string
  index: number
}

StepCard.defaultProps = {
  className: '',
}

function StepCard(props: Props) {
  const { index, headerText, contentText, className } = props
  const indexString = index.toString()
  return (
    <div className={classNames(style.wrapper, className)}>
      <BucketBadge className={style.stepNumber}>{indexString}</BucketBadge>
      <HeadlineFive>{checkStringPeriod(headerText)}</HeadlineFive>
      <p className={style.smallText}>{checkStringPeriod(contentText)}</p>
    </div>
  )
}

export default StepCard
